import { InfoCircleOutlined } from '@ant-design/icons';
import { Disclosure, Transition } from '@headlessui/react';
import classNames from 'classnames';

const Collapse = ({ title, children }) => {
    return (
        <Disclosure defaultOpen={true}>
            {({ open }) => (
                <>
                    <Disclosure.Button
                        disabled={false}
                        // className={classNames(
                        //     'flex w-full justify-between items-center rounded-xl bg-white px-4 py-2 text-left text-sm font-medium cursor-pointer border-none h-[50px] p-8 mt-6',
                        // )}
                        className={`flex w-full justify-between items-center ${open ? 'rounded-t-xl' : 'rounded-xl'} bg-white px-4 py-2 text-left text-sm font-medium cursor-pointer border-none h-[50px] p-8 mt-6`}
                    >
                        <div className="flex items-center space-x-2">
                            <span
                                className={classNames(
                                    'text-[#7B67FB] flex items-center space-x-2 text-xl font-semibold'
                                )}
                            >
                                <span>{title}</span>
                            </span>
                        </div>
                        <svg 
                            className={`${open ? 'rotate-180 transform' : ''}`}
                            width="16" 
                            height="17" 
                            viewBox="0 0 16 17" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path 
                                d="M2.20711 5.5C1.76165 5.5 1.53857 6.03857 1.85355 6.35355L7.64645 12.1464C7.84171 12.3417 8.15829 12.3417 8.35355 12.1464L14.1464 6.35355C14.4614 6.03857 14.2383 5.5 13.7929 5.5H2.20711Z" 
                                fill="#65707A" 
                            />
                        </svg>

                    </Disclosure.Button>
                    <Transition
                        show={open}
                        enter="transition duration-100 ease-out"
                        enterFrom="transform scale-95 opacity-0"
                        enterTo="transform scale-100 opacity-100"
                        leave="transition duration-75 ease-out"
                        leaveFrom="transform scale-100 opacity-100"
                        leaveTo="transform scale-95 opacity-0"
                    >
                        <Disclosure.Panel className="px-4 py-2 bg-white rounded-b-xl">
                            <hr	className='border-b border-solid border-[#ECECEC] -mt-2'></hr>
                            {children}
                        </Disclosure.Panel>
                    </Transition>
                </>
            )}
        </Disclosure>
    );
};

export default Collapse;
